import { asyncThunkWrapper } from "../handleAsyncThunk"
import { BASEURI, headers } from "../../utils/helper"
import { createAsyncThunk } from "@reduxjs/toolkit"

// Handle retrieve all
export const retrieveAllSpecialist = createAsyncThunk(
  "retrieveAll",
  async (data, thunkAPI) => {
    const params = {
      limit: data?.limit || null,
      status: data?.status || null,
      search: data?.search || null,
      currentPage: data?.currentPage || null,
    }

    return asyncThunkWrapper(
      {
        method: "GET",
        url: `${BASEURI}/admin/specialist/retrieve-all`,
        params,
        headers: headers()
      },
      thunkAPI,
      {
        showToast: false,
        returnDataKey: "data"
      }
    )
  }
)

// Handle retrieve single
export const retrieveSingleSpecialist = createAsyncThunk(
  "retrieveSingle",
  async (id, thunkAPI) =>
    asyncThunkWrapper(
      {
        method: "GET",
        url: `${BASEURI}/admin/specialist/retrieve/${id}`,
        headers: headers()
      },
      thunkAPI,
      {
        showToast: false,
        returnDataKey: "data"
      }
    )
)

// Update
export const updateSpecialist = createAsyncThunk(
  "update",
  async (data, thunkAPI) =>
    asyncThunkWrapper(
      {
        method: "POST",
        data: data?.formData,
        url: `${BASEURI}/admin/specialist/update/${data?.id}`,
        headers: headers()
      },
      thunkAPI,
      {
        returnDataKey: "data"
      }
    )
)
// update status - active 
export const updateSpecialistStatus = createAsyncThunk(
  "update",
  async (data, thunkAPI) => {
    asyncThunkWrapper(
      {
        method: "PUT",
        url: `${BASEURI}/admin/specialist/update/${data?.id}/status`,
        data: {
          status: data?.status
          , reason: data?.reason,

        },
        headers: headers()
      },
      thunkAPI
    )

  }
)
export const deleteSpecialist = createAsyncThunk(
  "delete",
  async (id, thunkAPI) =>
    asyncThunkWrapper(
      {
        method: "DELETE",
        url: `${BASEURI}/admin/specialist/delete/${id}`,
        headers: headers()
      },
      thunkAPI
    )
)
// redux/member-slices/verification.slice.js
export const sendVerificationEmail = createAsyncThunk(
  "create",
  async (data, thunkAPI) =>
    asyncThunkWrapper(
      {
        method: "POST",
        url: `${BASEURI}/admin/specialist/ask-verification`,
        data,
        headers: headers(),
      },
      thunkAPI,
      { successMsg: "Verification email sent!" }

    )
);

export const sendEmail = createAsyncThunk(
  "create",
  async (data, thunkAPI) =>
    asyncThunkWrapper(
      {
        method: "POST",
        url: `${BASEURI}/admin/specialist/send-mail`,
        data,
        headers: headers(),
      },
      thunkAPI,
      { successMsg: "Email sent Successfully!" }

    )
);


// retrieve all members of specialist

export const retrieveSpecialistMembers = createAsyncThunk(
  "retrieveAll",
  async (data, thunkAPI) => {
    const { userId, ...params } = data;

    return asyncThunkWrapper(
      {
        method: "GET",
        url: `${BASEURI}/admin/specialist/retrieve/${userId}/members`,
        params,
        headers: headers(),
      },
      thunkAPI,
      {
        showToast: false,
        returnDataKey: "data",
      }
    );
  }
);

// retrieve all appointments of specialist
export const retrieveSpecialistAppointments = createAsyncThunk(
  "retrieveAll",
  async (data, thunkAPI) => {
    const { userId, ...params } = data;

    return asyncThunkWrapper(
      {
        method: "GET",
        url: `${BASEURI}/admin/specialist/retrieve/${userId}/appointments`,
        params,
        headers: headers(),
      },
      thunkAPI,
      {
        showToast: false,
        returnDataKey: "data",
      }
    );
  }
);

// retrieve all basic details of specialist
export const retrieveSpecialistInfo = createAsyncThunk(
  "retrieveAll",
  async (data, thunkAPI) => {
    const { userId, ...params } = data;

    return asyncThunkWrapper(
      {
        method: "GET",
        url: `${BASEURI}/admin/specialist/retrieve/${userId}/info`,
        params,
        headers: headers(),
      },
      thunkAPI,
      {
        showToast: false,
        returnDataKey: "data",
      }
    );
  }
);
